$(function(){
    const Doms = {
        characteristicDetail: $('#characteristicDetail')
    }

    if(Doms.characteristicDetail.length) {
        loadJs('/themes/mall/default/js/min/apply-util.js');
        // 仅将旧代码从html分离，旧代码没有改
        new Vue({
            el: '#characteristicDetail',
            data() {
                return {
                    dialogVisible: false,
                    nofide: false,
                    pageinfo: {},
                    shopDetilInfo: {},
                    queryList: [
                        {
                            id: 0,
                            title: '商品'
                        },
                        {
                            id: 1,
                            title: '店铺'
                        },
                    ],
                    seachIndex: 0,
                    cIndex: 0,
                    citysList: [],
                    brandsList: [],
                    citysvalue: '',
                    brandvalue: '',
                    seachValue: '',
                    // 商铺列表
                    shopList: [],
                    // 商品列表
                    goodList: [],
                    sort: 1,
                    settle_in:0, //是否开启商家入驻，0 否，1 是
                }
            },
            created() {
                this.getList();
                this.isOpenMerchantSettled();
            },
            mounted() {
                $('#characteristicDetail').show()
            },
            methods: {
                displayMore(){
                    this.dialogVisible=true
                },
                //
                closeDialog() {
                    this.dialogVisible=false
                },
                // 判断是否开启商家入驻
                isOpenMerchantSettled(){
                    let lf_id = getUrlSearch('lf_id');
                    let that = this;
                    $.ajax({
                        type: 'post',
                        url: jkas.url('/wxxcx/xpfDetail'),
                        dataType: 'json',
                        data: {lf_id},
                        success: function (res) {
                            // console.log(res);
                            if(res.code == 10){
                                that.settle_in = res.data.settle_in;
                                let agent_no = res.data.agent_no;
                                sessionStorage.setItem('agent_no',JSON.stringify(agent_no));
                            }else{
                                layer.msg(res.rep_msg);
                            }
                        }
                    })
                },
                // 商家入驻
                merchantSettled(){
                    location.href = jkas.url('/supplier/index');
                },
                // 初始化数据
                async getList() {
                    var qs = Qs
                    // 2022/2/16 切换时有数据无需再请求 但这个对象初始化不时null
                    if(!this.shopDetilInfo.title) {
                        // 获取店铺信息
                        await axios({
                            method: 'post',
                            url: '/wxxcx/xpfDetail.htm',
                            data: qs.stringify({ lf_id: getUrlSearch('lf_id') }),
                            headers: {
                                // 'Content-Type': 'application/json'
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                        }).then(res => {
                            if(10 === res.data.code) {
                                this.shopDetilInfo = res.data.data
                            }
                        })
                    }

                    var queryData = {
                        page: this.pageinfo.page || 1,
                        pagenum: this.pageinfo.pagenum || 15,
                        lf_id: getUrlSearch('lf_id'),
                        keywords: this.seachValue,
                        city: this.citysvalue,
                        sort: this.sort,
                        show_brands: 1,
                        brand_id: this.brandvalue
                    }
                    // 初始化数据，调用商品列表
                    if (this.seachIndex == 0) {
                        await axios({
                            method: 'post',
                            url: '/wxxcx/searchGoodsXcx.htm',
                            data: qs.stringify(queryData),
                            headers: {
                                // 'Content-Type': 'application/json'
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                        }).then(res => {
                            this.pageinfo = res.data.pageinfo
                            this.citysList = res.data.citys
                            this.brandsList = res.data.brands || []
                            this.goodList = res.data.list
                        })
                    } else if (this.seachIndex == 1) {

                        await axios({
                            method: 'post',
                            url: '/wxxcx/searchShopsXcx.htm',
                            data: qs.stringify(queryData),
                            headers: {
                                // 'Content-Type': 'application/json'
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                        }).then(res => {
                            this.pageinfo = res.data.pageinfo
                            this.citysList = res.data.citys
                            this.shopList = res.data.list
                        })
                    }

                },
                query() {
                    this.getList()
                },
                // 点击分类查询
                clickQueryList(val, index) {
                    this.seachIndex = index
                    this.resetAll()
                    this.getList()
                },
                // 点击筛选
                clickComprehensive(index) {

                    this.cIndex = index
                    if (index == 0) {
                        this.sort = 1
                        $('.icon-top').css({ color: '#222' })
                        $('.icon-but').css({ color: '#222' })
                    } else if (index == 1) {
                        this.sort = 2
                        $('.icon-top').css({ color: '#222' })
                        $('.icon-but').css({ color: '#222' })
                    } else if (index == 2) {
                        if (this.jgHide == 'top') {
                            this.clickJG('dow')
                        } else {
                            this.clickJG('top')
                        }
                    }
                    this.resetAll()
                    this.getList()
                },
                // 点击价格排行
                clickJG(val) {
                    this.jgHide = val
                    if (val == 'top') {
                        $('.icon-but').css({ color: '#9e9e9e' })
                        $('.icon-top').css({ color: '#222' })
                        this.sort = 3
                        this.getList()
                    } else if (val == 'dow') {
                        $('.icon-top').css({ color: '#9e9e9e' })
                        $('.icon-but').css({ color: '#222' })
                        this.sort = 4
                        this.getList()
                    }
                },
                // 选择城市
                selectCity(val) {
                    this.cIndex = 3
                    this.getList()
                },
                // 选择品牌
                selectBrand(val) {
                    this.getList()
                },
                // 分页切换
                handleSizeChange(val) {
                    this.pageinfo.pagenum = val
                    this.getList()
                },
                // 分页切换
                handleCurrentChange(val) {
                    this.pageinfo.page = val
                    this.getList()
                },
                resetAll() {
                    this.pageinfo.page = 1
                    this.pageinfo.pagenum = 15
                    this.seachValue = ''
                    this.citysvalue = ''
                    this.brandvalue = ''
                }
            },
        })
    }
});